import React, { useState } from "react";
import logo1 from './logo1.jpg';

import './App.css';
import { Link, Routes, Route, useNavigate } from 'react-router-dom';
function Home() {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    email: "",
  });
  let name, value;
  const getData = (event) => {
    name = event.target.name;
    value = event.target.value;

    setUser({ ...user, [name]: value });
  };
  // const handleSubmit = event => {
  //   event.preventDefault();

  //   // 👇️ redirect to /contacts
  //   navigate('/contacts');
  // };
  const postData = async (e) => {
    e.preventDefault();
    const { email } = user;

    if (email) {
      const res = await fetch("https://authoropodmagazineedition-default-rtdb.firebaseio.com/july-edition.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({

          email

        }),
      });
      if (res) {
        setUser({
          email: "",
        });
        navigate('/magazine');
      }
    } else {

      alert("Please Fill All The Details..")
    }
  }
  return (<>
    <div className='w-100 container-fluid nav1'>
      <div className='row1' >
        <img src={logo1} className='img1' />
        <h3>All About Books & Authors !</h3>
      </div>
      {/* <h1 className="Athoropod mt-3">Authoropod</h1> */}

    </div>
    <div className="App">
      <div className="formDesign">
        <h6 style={{ fontSize: "20px" }}>Our July 2022 Edition Is Out Now..</h6>
        <form onSubmit={postData} >

          <input
            className="inputbox"
            aria-label="Your email address"
            placeholder="Enter your email address"
            required
            type="email"
            name="email"
            value={user.email}
            onChange={getData}
            style={{ width: "400px", height: "30px", paddingLeft: "10px" }}
          /><br />
          <button className="btnSub" >Subscribe</button>
        </form>
      </div>
    </div></>
  );
}
export default function App() {
  return (
    <div>
      <div>
        {/* <nav>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/contacts">Contacts</Link>
            </li>
          </ul>
        </nav> */}

        <Routes>
          <Route path="/magazine" element={<Magazine />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </div>
  );
}

function Magazine() {
  return (<>
  <div className='w-100 container-fluid nav1'>
      <div className='row1' >
        <img src={logo1} className='img1' />
        <h3>All About Books & Authors !</h3>
      </div>
      {/* <h1 className="Athoropod mt-3">Authoropod</h1> */}

    </div>
  
    <div className="App">
      <div className="paraBox">
        <h4 style={{ fontSize: "25px" }}>Welcome To Authoropod</h4>
        <h5 style={{ fontSize: "20px" }}>Have A Look..!</h5>
        {/* <p className="DownloadFile">  <a style={{textDecoration:"none",color:"white"}} href="Document URL" attributes-list download > Download Pdf </a>
  
            </p> */}
        <p className="DownloadFile"><a style={{ textDecoration: "none" }} href="https://online.fliphtml5.com/fzdkb/erua/#p=1"  > <button style={{ width: "270px", height: "50px", background: "black", color: "white" }}> Flip Book </button> </a>

        </p>
        {/* <p>Please check your inbox to confirm the subscription!</p> */}
        <div className="backBtn">
          <a href="/" style={{ textDecoration: "none", color: "white" }} > Back To Home </a>

        </div>
        <div className="backBtn2">
          <a href="https://authoropod-magazine.vercel.app/" style={{ textDecoration: "none", color: "white" }} > Go To Authoropod Official Website </a>

        </div>
      </div> </div>
      </>
  );
}
